export const defaultMapCenter = {
    lat: 38.5,
    lng: -98,
}
